import { render, staticRenderFns } from "./AppOrgInvite.vue?vue&type=template&id=4fad2a30&scoped=true&"
import script from "./AppOrgInvite.vue?vue&type=script&lang=js&"
export * from "./AppOrgInvite.vue?vue&type=script&lang=js&"
import style0 from "./AppOrgInvite.vue?vue&type=style&index=0&id=4fad2a30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fad2a30",
  null
  
)

export default component.exports